import React, { CSSProperties, FC, ReactNode } from 'react';
import Row from 'components/common/Row';
import Text from 'components/common/Text';

interface Props {
  title: string | ReactNode;
  isMobile: boolean;
  contents?: ReactNode;
  style?: CSSProperties;
}

const TitleContainer: FC<Props> = props => {
  const { title, isMobile, contents, style } = props;

  return (
    <Row
      justifyContent="flex-start"
      style={{
        position: 'sticky',
        top: 0,
        padding: isMobile ? '8px 0 32px' : '32px 0',
        width: '100%',
        height: isMobile ? 'auto' : '100px',
        background: '#fff',
        zIndex: 12,
        ...style,
      }}
    >
      <Text color="#1B1C1E" size="24px" weight={500}>
        {title}
      </Text>
      {contents && contents}
    </Row>
  );
};

export default TitleContainer;
